import * as yup from 'yup';
import { UserPermissionsSchema } from './UserPermissionsSchema';

export const PermissionsResponseSchema = yup.object({
  object_type: yup.string(),
  object_id: yup.string(),
  meta: yup.object({
    next_token: yup.string().defined(),
    prev_token: yup.string().defined().nullable(),
  }),
  user_permissions: yup.array().of(UserPermissionsSchema).defined(),
});
export type PermissionsResponse = yup.InferType<
  typeof PermissionsResponseSchema
>;

export const PermissionsUpdateResponseSchema = yup.object({
  object_type: yup.string(),
  object_id: yup.string(),
  actions: yup
    .array()
    .of(
      yup.object({
        action: yup.string(),
        user_id: yup.string().nullable(),
        usesr_type: yup.string().nullable(),
        role_ids: yup.array().of(yup.string()).nullable(),
        success: yup.boolean(),
        errors: yup
          .array()
          .of(
            yup.object({
              code: yup.number().defined(),
              message: yup.string().defined(),
            }),
          )
          .defined(),
        path: yup.string().nullable(),
      }),
    )
    .defined(),
});
export type PermissionsUpdateResponse = yup.InferType<
  typeof PermissionsUpdateResponseSchema
>;
